const footerGroups = [
  {
    title: '快速导航',
    links: [
      { label: '今日更新', href: '#today' },
      { label: '热门影片', href: '#hot' },
      { label: '电影大全', href: '#genres' },
      { label: '高清专区', href: '#hd' },
    ],
  },
  {
    title: '内容精选',
    links: [
      { label: '经典高分', href: '#classic' },
      { label: '即将上线', href: '#upcoming' },
      { label: '观影指南', href: '#guide' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '题材分类',
    links: [
      { label: '动作片', href: '#genres' },
      { label: '科幻片', href: '#genres' },
      { label: '悬疑片', href: '#genres' },
      { label: '纪录片', href: '#genres' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">西瓜影院</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/80 max-w-md">
              西瓜影院专注于整理最新电影资源，汇集电影大全、高清电影、今日更新与热门影片。
              无论你想追新片还是重温经典，都能在这里快速找到播放入口，享受流畅的观影体验。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full bg-secondary-900 text-secondary-100 text-xs">每日更新</span>
              <span className="px-3 py-1 rounded-full bg-secondary-900 text-secondary-100 text-xs">4K 高清</span>
              <span className="px-3 py-1 rounded-full bg-secondary-900 text-secondary-100 text-xs">多题材覆盖</span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200/80 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/70">
            本站为影视资讯与资源整理示范站点，片名与资料均为演示内容，仅供产品展示使用。
          </p>
          <p className="text-xs text-background-300/70">© 2026 西瓜影院 · 电影资源整理</p>
        </div>
      </div>
    </footer>
  );
}